import { render } from "./XIconSolidLayoutGrid.vue?vue&type=template&id=193f38b1"
import script from "./XIconSolidLayoutGrid.vue?vue&type=script&lang=js"
export * from "./XIconSolidLayoutGrid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLayoutGrid.vue"]])

export default __exports__